import React from 'react';

export const KTexts = {
  title: {
      ko: (
        <>
          진짜 본인 인증? 진짜 본인 확인?
        </>
      ),
      en: (
        <>
          Real Identity Verification? Real Identity Confirmation?
        </>
      )
  },
  subtitle: {
      ko: (
        <>
          1KOSMOS
        </>
      ),
      en: (
        <>
          1KOSMOS
        </>
      )
  }
};

export const outlineTexts = {
  title: {
      ko: (
        <>
          1KOSMOS 개요
        </>
      ),
      en: (
        <>
          1KOSMOS Overview
        </>
      )
  },
  subtitle: {
      ko: (
        <>
          높은 신뢰도를 위한 강력히 검증된 신원 확인과 안전한 디지털 지갑
        </>
      ),
      en: (
        <>
          Strongly verified identity verification and secure digital wallet for high trust
        </>
      )
  },
  message: {
      ko: (
        <>
          피싱이 불가능한 비밀번호 없는 MFA를 통해 사용자의 접근을 간소화하고,
          외부 위헙으로 부터 디지털 서비스를 보호하는 방법을 제공합니다.
        </>
      ),
      en: (
        <>
          Provides a way to protect digital services from external threats through 
          passwordless MFA that is phishing-resistant.
        </>
      )
  }
};

export const specialTexts = {
  title: {
      ko: (
        <>
          1KOSMOS 특징
        </>
      ),
      en: (
        <>
          1KOSMOS Features
        </>
      )
  },
  platformtitle: {
      ko: (
        <>
          통합 플렛폼
        </>
      ),
      en: (
        <>
          Unified Platform
        </>
      )
  },
  platformmessage: {
      ko: (
        <>
          신원 확인과 비밀번호 없는 인증을 통합하는 분산형 클라우드 서비스 입니다.
        </>
      ),
      en: (
        <>
          A distributed cloud service that integrates identity verification and passwordless authentication.
        </>
      )
  },
  usertitle: {
      ko: (
        <>
          마찰 없는 사용자 경험
        </>
      ),
      en: (
        <>
          Frictionless user experience
        </>
      )
  },
  usermessage: {
      ko: (
        <>
          간편한 사용자 온보딩과 언제 어디서나 어떤 기기에서나 편리한 접속이 가능합니다.
          </>
      ),
      en: (
        <>
          Easy user onboarding and convenient access anytime, anywhere, on any device.
        </>
      )
  },
  privacytitle: {
      ko: (
        <>
          개인정보 보호 및 동의
        </>
      ),
      en: (
        <>
          Privacy Protection and Consent
        </>
      )
  },
  privacymessage: {
      ko: (
        <>
          사용자는 자신의 개인 데이터를 완벽하게 통제하고, 언제, 누구와 공유할지 결정합니다.
          </>
      ),
      en: (
        <>
          Users have complete control over their personal data and decide when and with whom to share it.
        </>
      )
  },
  devtitle: {
      ko: (
        <>
          개발 친화적
        </>
      ),
      en: (
        <>
          Developer Friendly
        </>
      )
  },
  devmessage: {
      ko: (
        <>
          개발자 친화적인 SDK, API 및 50개 이상의 기본 통합을 통해 쉽게 배포할 수 있습니다.
          </>
      ),
      en: (
        <>
          Easily deployable with developer-friendly SDKs, APIs, and over 50 out-of-the-box integrations.
        </>
      )
  },
  liveidtitle: {
      ko: (
        <>
          실제 생체 인식
        </>
      ),
      en: (
        <>
          Live Biometric Recognition
        </>
      )
  },
  liveidmessage: {
      ko: (
        <>
          고급 생체 인식으로 위조를 제거하고 99% 이상의 정확도로 사용자를 확인합니다.
          </>
      ),
      en: (
        <>
          Advanced biometric recognition eliminates spoofing and verifies users with over 99% accuracy.
        </>
      )
  },
  certititle: {
      ko: (
        <>
          규정 준수,표준 및 인증
        </>
      ),
      en: (
        <>
          Compliance, Standards, and Certifications
        </>
      )
  },
  certimessage: {
      ko: (
        <>
          NIST 800.63.3, UK-DIATF, FIDO2, ISO/IEC 30107-1 및 30107-3, ISO 27001 및 SOC II Type 2 인증을 받았습니다. GDPR을 준수합니다.
          </>
      ),
      en: (
        <>
          Certified with NIST 800.63.3, UK-DIATF, FIDO2, ISO/IEC 30107-1 and 30107-3, ISO 27001, and SOC II Type 2. Compliant with GDPR.
        </>
      )
  }

};

export const functionTexts = {
  title: {
      ko: (
        <>
          1KOSMOS 제품
        </>
      ),
      en: (
        <>
          1KOSMOS Products
        </>
      )
  },
  verify:
    {
      title: {
        ko: '1KOSMOS Verify',
        en: '1KOSMOS Verify'
      },
      desc: {
        ko: <>
              1Kosmos Verify는 브라우저, 모바일 앱, 앱 없는 인터페이스를 통해 원격 및 대면 신원 확인을 위한 셀프서비스 워크플로우를 제공합니다. 
              <br />은행, 통신사, 정부 발급 신분증(150개국 이상 지원) 등을 활용해 KYC/AML, NIST IAL2 수준의 신원 확인을 수행하며, 사기꾼과 정당한 사용자를 구분하고 수동 검토를 최소화합니다. 
              <br />1:1 얼굴 매칭으로 공정하고 객관적인 검증을 보장하며, 신원 사기를 줄이고 운영 비용 및 규제 리스크를 최소화합니다. 
              <br />독립 실행형 또는 화이트라벨 앱, API/SDK를 통해 기존 시스템에 통합 가능하며, 관리형 서비스로도 제공됩니다. 
              <br />1Kosmos Customer/Workforce와 연계 시 비밀번호 없는 디지털 지갑으로 다양한 서비스 접근이 가능합니다.
        </>,
        en: <>
              1Kosmos Verify provides self-service workflows for remote and in-person identity verification through browser, mobile app, or app-less interfaces.
              <br />Identity verification can be performed at various levels using bank, telecom, email, social security number, phone number, or government-issued ID,
              <br />meeting NIST 800-63-3 Identity Assurance Level 2 (IAL2) for KYC/AML regulations, worker qualification requirements, digital delivery of government and healthcare services, and other commercial applications.
              <br />IAL2 level identity verification effectively distinguishes between fraudsters hiding behind stolen or synthetic identities and legitimate users, minimizing manual review.
              <br />Government-issued IDs can be verified in over 150 countries.
              <br />1:1 face matching eliminates bias in race and gender, and provides objective, fair, and transparent identity verification processes,
              <br />minimizing manual processes and exceeding industry benchmarks to remove identity theft and reduce operational costs while minimizing regulatory compliance risks.
              <br />1Kosmos Verify is an independent application that can be used independently, through a fully branded mobile app accessible via white-label, or through standard APIs and SDKs integrated into existing applications and mobile apps.
              <br />Additionally, 1Kosmos Customer and 1Kosmos Workforce can provide managed services through
        </>
      }
    },
  workforce: 
    {
      title: {
        ko: '1KOSMOS Workforce',
        en: '1KOSMOS Workforce'
      },
      desc: {
        ko: <>
              1Kosmos Workforce는 비밀번호와 기존 2FA를 대체하는 안전한 비밀번호 없는 다단계 인증(MFA) 솔루션입니다. 
              <br />OAuth, OIDC, SAML, RADIUS, FIDO를 지원하며, Microsoft Azure, Windows, Mac 등 다양한 엔터프라이즈 환경에 빠르게 배포 가능합니다. 
              <br />푸시 알림, OTP, FIDO2, 패스키, 생체 인식(얼굴, 지문), LiveID(NIST AAL2 준수) 등 다양한 인증 방법을 제공합니다. 
              <br />Entra ID, ADFS, 레거시 Windows 환경과 원활히 통합되며, 적응형 인증으로 장치, 사용자 행동, 위험 신호를 분석해 동적 인증 수준을 결정합니다. 
              <br />1Kosmos 1Key는 모바일 제한 환경에 적합한 비밀번호 없는 MFA를 제공하며, 액티브-액티브 중복 환경으로 99.999% 가용성을 보장합니다. 
              <br />모든 인증 이벤트는 불변의 감사 추적으로 기록되어 규정 준수와 보안 감독을 지원합니다.
        </>,
        en: <>
              1Kosmos Workforce is a secure passwordless multi-factor authentication (MFA) solution that replaces passwords and outdated 2FA methods.
              <br />Supporting OAuth, OIDC, SAML, RADIUS, and FIDO, it can be rapidly deployed across various enterprise environments, including Microsoft Azure, Windows, and Mac.
              <br />Our solution offers a wide range of authentication methods, including push notifications, one-time passwords (OTP), FIDO2, FIDO Passkeys, device biometrics, facial and fingerprint recognition, and LiveID—an identity-based biometric authentication certified to NIST Authentication Assurance Level 2 (AAL2) under the 800-63-3 specification.
              <br />1Kosmos Workforce seamlessly integrates as an External Authentication Method (EAM) for Entra ID and supports legacy Windows environments. It also provides an alternative, highly secure authentication option for environments supported by Microsoft Active Directory Federation Services (ADFS).
              <br />With adaptive authentication, 1Kosmos Workforce evaluates risk-based signals—such as device type, access request origin, user behavior, and historical patterns—to determine authentication assurance levels dynamically. Additionally, the 1Kosmos 1Key biometric security key enables a “register once, use anywhere” passwordless MFA experience, ideal for restricted environments where mobile devices and cameras are prohibited.
              <br />Designed for enterprise resilience, 1Kosmos Workforce operates in active-active “hot” redundant environments, ensuring 99.999% (“five 9s”) availability. Every authentication event is recorded in an immutable audit trail, delivering full visibility and auditability for compliance and security oversight.
        </>
      }
    },
  customer: 
    {
      title: {
        ko: '1KOSMOS Customer',
        en: '1KOSMOS Customer'
      },
      desc: {
        ko: <>
              1Kosmos Customer는 비밀번호와 기존 MFA를 대체해 강력한 신원 확인과 공개-개인 키 암호화를 통해 안전하고 마찰 없는 고객 인증 경험을 제공합니다. 
              <br />1분 이내 신원 확인으로 정당한 고객을 즉시 검증하고, 사기 및 계정 탈취 위험을 줄이며, 99% 이상의 정확도로 사기 관리와 운영 비용을 절감합니다. 
              <br />셀프서비스 워크플로우는 자가 주장 신원(이메일, SMS 등)부터 NIST IAL2 수준까지 사용자 정의 가능하며, 데이터 보존 없이 일회성 등록 또는 비밀번호 없는 디지털 지갑을 지원합니다. 
              <br />이 지갑은 다단계 인증, 제로 지식 증명(예: 나이 확인), 고객이 PII를 통제할 수 있는 분산 원장 기반의 보안 액세스를 제공해 온보딩을 가속화합니다.        </>,
        en: <>
              1Kosmos Customer provides a secure and frictionless customer authentication experience by replacing passwords and legacy MFA with strong identity verification and public-private key cryptography.
              <br />With identity verification in under a minute, legitimate customers are instantly validated, reducing fraud and account takeover risks while cutting fraud management and operational costs by over 99%.
              <br />The self-service workflow is customizable from self-asserted identity (email, SMS, etc.) to NIST IAL2 level, supporting one-time registration or passwordless digital wallets without data retention.
              <br />This wallet accelerates onboarding by providing multi-factor authentication, zero-knowledge proofs (e.g., age verification), and secure access based on a distributed ledger that allows customers to control their PII.
        </>
      }
    },
  csp: 
    {
      title: {
        ko: '1KOSMOS Credential Service Provider (CSP)',
        en: '1KOSMOS Credential Service Provider (CSP)'
      },
      desc: {
        ko: <>
              1Kosmos CSP는 셀프서비스 신원 확인을 통해 거주자 온보딩을 현대화하는 관리형 서비스로, 개인 정보 보호를 보장하는 디지털 신원 지갑을 제공해 정부 기관과 PII를 안전하게 공유합니다. 
              <br />FedRAMP High, NIST 800-63-3, FIDO2, ISO27001 등 산업 인증을 충족하며, 신원 사기와 계정 탈취를 차단하고, 합성/도난 신원을 감지해 사기 관리 및 운영 비용, 규제 리스크를 줄입니다. 
              <br />저마찰의 셀프서비스 신원 확인 및 인증으로 사용자 경험을 개선하며, 비접촉식 서비스 액세스를 지원해 기관의 리소스 효율성을 높입니다. 
              <br />1Kosmos는 유일한 FedRAMP High 및 Kantara Full Service NIST 800-63-3 인증 디지털 신원 지갑 솔루션입니다.        </>,
        en: <>
              The 1Kosmos CSP is a managed service that modernizes resident onboarding through self-service identity verification. It then provides a privacy-preserving digital identity wallet replacing the user ID and password for logging in, transacting, and secure sharing of PII with government agencies. This architectural advantage effectively shuts the door on identity fraud and account takeover while delivering an exceptional user experience.
              <br />The 1Kosmos platform is industry certified to FedRAMP High, NIST 800-63-3, FIDO2, ISO27001, SOC II Type 2, ISO/IEC 30107-1, and ISO/IEC 30107-3 specifications. As a result, it provides residents a modern, low friction, app or appless self-service identity verification and authentication journey anywhere, anytime, and with or without a personal device. This detects synthetic and stolen identities, reduces operating and fraud management costs and minimizes compliance risk.
              <br />Deploying 1Kosmos as a CSP means that agencies can allocate their limited resources more effectively while still providing eligible residents convenient access to contactless services.
              <br />1Kosmos is the only FedRAMP High Authorized, Kantara Full Service NIST 800-63-3 certified, digital identity wallet solution.
            </>,
      }
    }
}

export const certTexts = {
  title: {
      ko: (
        <>
          인증
        </>
      ),
      en: (
        <>
          Certifications
        </>
      )
  }
};
